import axios from 'axios';

const setAuthToken = token => {
    if(token){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.defaults.headers.post['Content-Type'] = 'application/json';
    } else {
        delete axios.defaults.headers.common['Authorization']; 
    }
}

export default setAuthToken;


